import React from "react";
import { withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import CachedIcon from "@material-ui/icons/Cached";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import Box from "../../../../../../ui/Box";
import SquareButton from "../../../../../../ui/SquareButton";
import Button from "../../../../../../ui/Button";
import ActionsMenu from "../../../../../../ui/ActionsMenu";
import UndoIcon from '@material-ui/icons/Undo';

const useStyles = makeStyles(() => ({
  topBar: {
    display: "flex",
    justifyContent: "space-between"
  },
  topBarLeft: {
    display: "flex",
    "& > button": {
      marginRight: 12
    }
  },
  topBarRight: {
    display: "flex",
    "& > div": {
      marginLeft: 12
    },
    "& > button": {
      marginLeft: 12
    }
  }
}));

const TopBar = ({
  onReload,
  returnBack,
  onUpdate,
  isUpdating,
  openDeleteModal,
  disabled,
  editmode,
  setEditMode,
  setViewMode,
  onViewQuiz
}) => {
  const classes = useStyles();

  const actions = [
    {
      label: "Удалить опрос",
      onClick: openDeleteModal
    },
    {
      label: "Создать копию",
      disabled: true
    },
    {
      label: "Деактивировать",
      disabled: true
    }
  ];

  return (
    <Box>
      <div className={classes.topBar}>
        <div className={classes.topBarLeft}>
          <SquareButton onClick={returnBack}>
            <ChevronLeftIcon fontSize="small" />
          </SquareButton>
          <SquareButton onClick={onReload}>
            <CachedIcon fontSize="small" />
          </SquareButton>
        </div>
        <div className={classes.topBarRight}>
        {editmode ?
         (<>
           <SquareButton onClick={setViewMode} title="Вернуться в режим просмотра">
             <UndoIcon fontSize="small" />
           </SquareButton>
          <Button
            onClick={onUpdate}
            disabled={disabled}
            loading={isUpdating}
            color="green"
          >
            Сохранить
          </Button>
        </>)
        :(
          <>
         <Button
           onClick={setEditMode}
           color="gray">
           Редактировать
         </Button>
       </>
       )}

       <ActionsMenu actions={actions} />
     </div>
      </div>
    </Box>
  );
};

export default withRouter(TopBar);
